export default function ({ store, redirect }) {
  return redirect('/Index')
}
